import { toasterApi } from '../../toast/ToastProvider';

export const notifyEnrollmentActionFailure = ({
  error,
  errorTitle,
  operation,
}: {
  error: unknown;
  errorTitle: string;
  operation: string;
}): void => {
  console.error(new Error(`Failed to ${operation}`, { cause: error }));
  toasterApi.error({
    title: errorTitle,
    description: error instanceof Error ? error.message : undefined,
  });
};
